import { controlType, deviceType } from "constant";

export const getGuardianState = (cars) => {
  const carList = Array.isArray(cars) ? cars : cars ? [cars] : [];

  let disabled = false;
  let checked = true;

  for (const car of carList) {
    const dev = car?.DevType;
    const ctl = car?.CarControlType;

    const unsupported =
      (dev === deviceType.FT2 && ctl === controlType.None) ||
      ([deviceType.VDU3, deviceType.VDU4].includes(dev) &&
        ctl === controlType.Fusion &&
        car?.BatteryLevel > 100);

    if (unsupported) {
      disabled = true;
      checked = false;
      break;
    }

    const supportsGuardian =
      (
        (dev === deviceType.FT2 ||
          [deviceType.VDU3, deviceType.VDU4].includes(dev)) &&
        (ctl === controlType.LIN || ctl === controlType.Fusion)
      ) ||
      ([deviceType.VDU3, deviceType.VDU4].includes(dev) &&
        ctl === controlType.GCCM);

    if (supportsGuardian && !car?.GuardianCapable) {
      checked = false;
    }
  }

  return { disabled, checked };
};